import { render, staticRenderFns } from "./newTask.vue?vue&type=template&id=49339469&scoped=true"
import script from "./newTask.vue?vue&type=script&lang=js"
export * from "./newTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49339469",
  null
  
)

export default component.exports